import { useEffect } from "react";

/** Tab chrome for the Drive-served viewers (share-link, published space). */
export const DRIVE_FAVICON_HREF =
  process.env.PUBLIC_URL + "/assets/faviconDrive.png";
export const DRIVE_PRODUCT_NAME = "TeamBeam Drive";

/**
 * Overrides the document title and/or favicon for the lifetime of the calling
 * page, restoring the previous values on unmount.
 */
export function usePageChrome({
  title,
  faviconHref,
}: {
  /** Document title; pass `undefined` to leave the current title untouched. */
  title?: string;
  /** Favicon URL; pass `undefined` to leave the current favicon untouched. */
  faviconHref?: string;
}): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);

  useEffect(() => {
    if (!faviconHref) return;
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) return;
    const previousHref = link.href;
    const previousType = link.getAttribute("type");
    link.href = faviconHref;
    link.type = "image/png";
    return () => {
      link.href = previousHref;
      if (previousType) link.type = previousType;
      else link.removeAttribute("type");
    };
  }, [faviconHref]);
}
